/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/replace.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'The function substitutes in the string `str` any match of the regular expression `regex`\nwith the replacement string `newStr`.',
  examples: [
    'ROW str = "Hello World"\n| EVAL str = REPLACE(str, "World", "Universe")',
    'ROW str = "Hello World"\n| EVAL str = REPLACE(str, "\\\\\\\\s+", "")',
  ],
  params: {
    string: 'String expression.',
    regex: 'Regular expression.',
    newString: 'Replacement string.',
  },
};

export default docs;
